import React, { useEffect, useState } from 'react';
import './WorkshopDetailsPage.scss';
import TitlePage from '../../components/TitlePage/TitlePage';
import { Helmet } from 'react-helmet-async';
import Subscribe from './components/Subscribe/Subscribe';
import MainGoal from './components/MainGoal/MainGoal';
import Trailer from './components/Trailer/Trailer';
import ForYou from './components/ForYou/ForYou';
import Goal from './components/Goal/Goal';
import ForYou2 from './components/ForYou2/ForYou2';
import BecomeParent from './components/BecomeParent/BecomeParent';
import MeToo from './components/MeToo/MeToo';
import GoToWorkshop from './components/GoToWorkshop/GoToWorkshop';
import WithWorkshop from './components/WithWorkshop/WithWorkshop';
import Imagine from './components/Imagine/Imagine';
import Steps from './components/Steps/Steps';
import HowHappen from './components/HowHappen/HowHappen';
import BonusAnnounce from './components/BonusAnnounce/BonusAnnounce';
import Bonus from './components/Bonus/Bonus';
import AccessOfferTitle from './components/AccessOfferTitle/AccessOfferTitle';
import AccessOfferFare from './components/AccessOfferFare/AccessOfferFare';
import ColoredList from './components/ColoredList/ColoredList';
import Plans from './components/Plans/Plans';
import TextWith2Pictures from './components/TextWith2Pictures/TextWith2Pictures';
import { useLocation } from 'react-router-dom';
import { baseStrapiURL, baseURL } from '../../services/config';
import { isExternalLink, safeHtml } from '../../services/helpers';
import { useCollectionQuery } from '../../services/strapi/hooks';
import Loading from '../../components/Loading/Loading';
import { useQueryClient } from '@tanstack/react-query';
import Error404Page from '../Error404Page/Error404Page';
import FreeText from './components/FreeText/FreeText';
import CustomBtn from '../../components/CustomBtn/CustomBtn';
import Space from './components/Space/Space';
import Picture from './components/Picture/Picture';
import { strapiTrainingService } from '../../services/api/strapiTraining';
import { jwtDecode } from 'jwt-decode';
import StripeTestComponent from '../../components/StripeTestComponent/StripeTestComponent';
import PaymentSection from './components/PaymentSection/PaymentSection';
import { useAuth } from '../../contexts/AuthContext';

export default function WorkshopDetailsPage() {
    const location = useLocation();
    const { user, isAuthenticated } = useAuth(); 
    const [slug, setSlug] = useState('');
    const collectionType = 'atelier';
    const [training, setTraining] = useState(null);
    const [isRegistered, setIsRegistered] = useState(false)

    const strapiPage = 'ateliers';

    const queryClient = useQueryClient();

    useEffect(() => {
        if (location.pathname === '/cercles-de-mamans' || location.pathname === '/accompagnement-individuel') {
            setSlug(location.pathname.slice(1));
        } else {
            setSlug(location.pathname.slice(10));
        }
    }, [location])


    // Utilisation du hook personnalisé pour récupérer les données
    const { data: strapiData, isLoading, error } = useCollectionQuery(
        strapiPage,
        slug,
        true
    );

    // Obtenir les données mises en cache ou les données actuelles
    const displayData = strapiData || queryClient.getQueryData(['strapi-content', strapiPage]);

    // N'afficher le chargement que si les données ne sont pas disponibles
    const showLoading = isLoading && !displayData;

    const [backgroundImage, setBackgroundImage] = useState('');

    // Effet pour mettre à jour l'image de fond lorsque les données sont chargées
    useEffect(() => {
        if (displayData && displayData.ArrièrePlan_Principal) {
            setBackgroundImage(baseStrapiURL + displayData.ArrièrePlan_Principal.url);

            // Vérifier le support WebP
            const checkWebPSupport = () => {
                const img = new Image();
                img.onload = () => {
                    if (img.height > 0 && img.width > 0) {
                        setBackgroundImage(baseStrapiURL + displayData.ArrièrePlan_Principal.url);
                    }
                };
                img.onerror = () => setBackgroundImage(baseStrapiURL + displayData.ArrièrePlan_Principal.url);
                img.src = baseStrapiURL + displayData.ArrièrePlan_Principal.url;
            };

            checkWebPSupport();


            // Recherche de la formation associée à l'atelier
            const fetchTrainingData = async () => {
            try {
                
                /* setLoading(true); */

                const trainingPromise = strapiTrainingService.getTrainingBySlug(displayData.Slug);

                // Attendre que la promesse soit résolue
                const training = await trainingPromise;
                console.log('Training:', training);
                setTraining(training.data);
            } catch (error) {
                console.log(error.message);
            } finally {
                /* setLoading(false); */
            }
        };

        fetchTrainingData();
        }
    }, [displayData]);

    useEffect(() => {
        window.scroll(0, 0);
    }, [])

    useEffect(() => {
        const checkWebPSupport = () => {
            const img = new Image();
            img.onload = () => {
                if (img.height > 0 && img.width > 0) {
                    setBackgroundImage(baseStrapiURL + displayData.ArrièrePlan_Principal.url);
                }
            };

        };
        checkWebPSupport();
    }, []);

    const [displayedPaymentSection, setDisplayedPaymentSection] = useState(false);

    const handleClickToGoal = () => {
        setDisplayedPaymentSection(false);

        // Utiliser requestAnimationFrame pour attendre le prochain cycle de rendu
        requestAnimationFrame(() => {
            const anchorElement = document.getElementById('workshop-details-page__content');
            if (anchorElement) {
                anchorElement.scrollIntoView({ behavior: 'smooth' });
            }
        });
    };

    const handleClickToPlans = () => {
        setDisplayedPaymentSection(false);

        // Utiliser requestAnimationFrame pour attendre le prochain cycle de rendu
        requestAnimationFrame(() => {
            const anchorElement = document.getElementsByClassName('workshop-plans')[0];
            console.log('anchorElement', anchorElement);
            if (anchorElement) {
                anchorElement.scrollIntoView({ behavior: 'smooth' });
            }
        });
    };


    /* useEffect(() => {
        const checkUserRegistration = async () => {
            const token = localStorage.getItem('strapiToken');

            if (!token) {
                setIsRegistered(false);
                return;
            }

            try {
                // Utiliser votre service existant
                const userTrainings = await strapiTrainingService.getUserTrainings();

                // Vérifier si le slug de la formation correspond
                const isRegistered = userTrainings.data?.some(
                    training => training.slug === slug
                );

                setIsRegistered(isRegistered);
            } catch (error) {
                console.error('Erreur lors de la vérification:', error);
                setIsRegistered(false);
            }
        };

        setSlug(location.pathname.slice(10));
        checkUserRegistration();
    }, [location, slug]); */


    useEffect(() => {
        setSlug(location.pathname.slice(10));

        console.log('user')
        console.log(user)
        
        // 👇 VERSION SIMPLE ET RAPIDE (pas d'appel API !)
        if (!isAuthenticated || !user) {
            setIsRegistered(false);
            return;
        }
        
        // Vérifier si le slug de la formation correspond
        const hasTraining = user.trainings?.some(
            training => training.slug === slug
        );
        
        setIsRegistered(hasTraining);
        
    }, [location, slug, user, isAuthenticated]);

    

    const displayPaymentSection = () => {
        setDisplayedPaymentSection(true);
        /* window.scroll(0, 0); */
        // Utiliser requestAnimationFrame pour attendre le prochain cycle de rendu
        requestAnimationFrame(() => {
            const anchorElement = document.getElementsByClassName('workshop-payment-section')[0];
            if (anchorElement) {
                anchorElement.scrollIntoView({ behavior: 'smooth' });
            }
        });
    }

    const displayProgramSection =() => {
        setDisplayedPaymentSection(false);
        /* window.scroll(0, 0); */
    }
    // State pour gérer l'affichage de la section de paiement

    if (showLoading) return <Loading />;
    if (!displayData || displayData.length === 0 || error) return <Error404Page />;

    console.log('formation_liee:', displayData?.formation_liee);

    
    return (
        <div className="workshop-details-page">
            {
                displayData.id &&
                <>
                    <Helmet>
                        {/* Open Graph (utilisé par Facebook, LinkedIn, etc.) */}
                        <meta property="og:title" content={displayData.SEO.TitreOnglet} />
                        <meta property="og:description" content={displayData.SEO.Description} />
                        <meta property="og:image" content={baseStrapiURL + displayData.SEO.PhotoReseauxSociaux_1200x630.url} />
                        <meta property="og:url" content={displayData.Slug === null ? baseURL : baseURL + '/ateliers/' + displayData.Slug} />
                        <meta property="og:type" content="website" />

                        {/* Twitter Cards */}
                        <meta name="twitter:card" content="summary_large_image" />
                        <meta name="twitter:title" content={displayData.SEO.TitreOnglet} />
                        <meta name="twitter:description" content={displayData.SEO.Description} />
                        <meta name="twitter:image" content={baseStrapiURL + displayData.SEO.PhotoReseauxSociaux_1200x630.url} />
                        <meta name="twitter:url" content={displayData.Slug === null ? baseURL : baseURL + '/ateliers/' + displayData.Slug} />

                        <title>{displayData.SEO.TitreOnglet}</title>
                        <meta name="description" content={displayData.SEO.Description} />
                        <link
                            rel="preload"
                            as="image"
                            href={baseStrapiURL + displayData.TitrePage_section.TitrePage.Photo.url}
                            fetchPriority="high"
                        />
                    </Helmet>
                    <div className="workshop-details-page__title-container" style={{ position: 'relative', zIndex: 2 }}>
                        <TitlePage
                            picture={displayData.TitrePage_section.TitrePage.Photo}
                            title1={displayData.TitrePage_section.TitrePage.Titre1}
                            font1={displayData.TitrePage_section.TitrePage.Typographie1 === 'Great Vibes' ? "handwrite-title" : "classic-title"}
                            title2={displayData.TitrePage_section.TitrePage.Titre2}
                            font2={displayData.TitrePage_section.TitrePage.Typographie2 === 'Great Vibes' ? "handwrite-title" : "classic-title"}
                            withSubscribeBtn={!!displayData.TitrePage_section.BoutonInscription}
                        />
                        {
                            displayData.TitrePage_section.BoutonInscription &&
                            <Subscribe
                                displayedPaymentSection={displayedPaymentSection}
                                displayPaymentSection={displayPaymentSection}
                                isRegistered={isRegistered}
                                slug={slug}
                                contentBtn={displayData.TitrePage_section.BoutonContenu}
                                susbscribeBtn={displayData.TitrePage_section?.BoutonInscription}
                                handleClickToGoal={handleClickToGoal}
                                hasPlans={displayData.Zone_libre.some(section => section.__component === collectionType + ".plans")}
                                hasFormation={!!(displayData?.formation_liee)}
                            />
                        }
                    </div>
                    {/* {process.env.NODE_ENV === 'development' && <StripeTestComponent />} */}
                    {
                        displayedPaymentSection ?
                            <div className="workshop-details-page__content">
                                <PaymentSection
                                    workshopPaymentSection={displayData.Zone_libre}
                                    training={training}
                                    cancelBtn={displayProgramSection}
                                    workshop={{
                                        id: displayData.id,
                                        title1: displayData.TitrePage_section.TitrePage.Titre1,
                                        title2: displayData.TitrePage_section.TitrePage.Titre2,
                                        bkg: '',
                                        fare: ''
                                    }}
                                />
                            </div>
                        :
                            <div
                                id="workshop-details-page__content"
                                className="workshop-details-page__content"
                                style={{ position: 'relative', zIndex: 3, backgroundImage: `url(${backgroundImage})` }}
                            >
                                {
                                    displayData.Zone_libre.map((section, index) => (
                                        <React.Fragment key={index}>
                                            {
                                                section.__component === collectionType + ".maingoal" &&
                                                <MainGoal content={section} isAtelier={!!displayData.ListeAteliers} />
                                            }
                                            {
                                                section.__component === collectionType + ".videosection" &&
                                                <Trailer content={section} />
                                            }
                                            {
                                                section.__component === collectionType + ".foryou" &&
                                                <ForYou content={section} />
                                            }
                                            {
                                                section.__component === collectionType + ".goal" &&
                                                <div style={{ position: 'relative', zIndex: 3 }}>
                                                    <Goal content={section} />
                                                </div>
                                            }
                                            {
                                                section.__component === collectionType + ".partssection" &&
                                                <ForYou2 content={section} />
                                            }
                                            {
                                                section.__component === collectionType + ".becomeparent" &&
                                                <BecomeParent content={section} />
                                            }
                                            {
                                                section.__component === collectionType + ".metoo" &&
                                                <MeToo content={section} />
                                            }
                                            {
                                                section.__component === collectionType + ".gotoworkshop" &&
                                                <div style={{ position: 'relative', zIndex: 3 }}>
                                                    <GoToWorkshop content={section} />
                                                </div>
                                            }
                                            {
                                                section.__component === collectionType + ".coloredlist" &&
                                                <ColoredList content={section} />
                                            }
                                            {
                                                section.__component === collectionType + ".withworkshop" &&
                                                <WithWorkshop content={section} />
                                            }
                                            {
                                                section.__component === collectionType + ".imagine" &&
                                                <Imagine content={section} />
                                            }
                                            {
                                                section.__component === collectionType + ".steps" &&
                                                <div style={{ position: 'relative', zIndex: 3 }}>
                                                    <Steps content={section} />
                                                </div>
                                            }
                                            {
                                                section.__component === collectionType + ".howithappen" &&
                                                <div style={{ position: 'relative', zIndex: 3 }}>
                                                    <HowHappen content={section} />
                                                </div>
                                            }
                                            {
                                                section.__component === collectionType + ".bonusintro" &&
                                                <BonusAnnounce content={section} />
                                            }
                                            {
                                                section.__component === collectionType + ".modulessection" &&
                                                <Bonus content={section} slug={slug} />
                                            }
                                            {
                                                section.__component === collectionType + ".offer" &&
                                                <div style={{ position: 'relative', zIndex: 3 }}>
                                                    <>
                                                        <AccessOfferTitle content={section.Titre} />
                                                        <AccessOfferFare content={section} />
                                                    </>
                                                </div>
                                            }
                                            {
                                                section.__component === collectionType + ".plans" &&
                                                <Plans content={section} workshopTitle={displayData.TitrePage_section.TitrePage.Titre2} />
                                            }
                                            {
                                                section.__component === collectionType + ".textwithpictures" &&
                                                <TextWith2Pictures content={section} />
                                            }
                                            {
                                                section.__component === collectionType + ".freetexte" &&
                                                <FreeText content={section} />
                                            }
                                            {
                                                section.__component === "shared.marge" &&
                                                <Space content={section} />
                                            }
                                            {
                                                section.__component === collectionType + ".photo" &&
                                                <Picture content={section} />
                                            }
                                            {
                                                section.__component === "shared.button" &&
                                                <CustomBtn
                                                    type={isExternalLink(section.LienBouton) ? 'external' : 'internal'}
                                                    title={section.TexteBouton}
                                                    link={
                                                        section.LienBouton === null ?
                                                            ''
                                                            :
                                                            (isExternalLink(section.LienBouton) ?
                                                                section.LienBouton
                                                                :
                                                                '/' + section.LienBouton)
                                                    }
                                                    bkg_color={'transparent'}
                                                    bkg_color_hover={'#EEE6DB'}
                                                    text_color={'#361215'}
                                                    text_color_hover={'#361215'}
                                                    border_color={'#361215'}
                                                    border_color_hover={'#361215'}
                                                    font_family={"Great Vibes"}
                                                    font_size={'30px'}
                                                    font_weight={'normal'}
                                                    border_radius={'3px'}
                                                    width={'360px'}
                                                    height={'55px'}
                                                    margin={'10px 0'}
                                                    letter_spacing={'3px'}
                                                />
                                            }
                                            {
                                                section.__component === collectionType + ".freesection" &&
                                                section.Zone_libre.map((section, index) => (
                                                    <React.Fragment key={index}>
                                                        {
                                                            section.__component === collectionType + ".maingoal" &&
                                                            <MainGoal content={section} />
                                                        }
                                                        {
                                                            section.__component === collectionType + ".videosection" &&
                                                            <Trailer content={section} />
                                                        }
                                                        {
                                                            section.__component === collectionType + ".foryou" &&
                                                            <ForYou content={section} />
                                                        }
                                                        {
                                                            section.__component === collectionType + ".goal" &&
                                                            <div style={{ position: 'relative', zIndex: 3 }}>
                                                                <Goal content={section} />
                                                            </div>
                                                        }
                                                        {
                                                            section.__component === collectionType + ".partssection" &&
                                                            <ForYou2 content={section} />
                                                        }
                                                        {
                                                            section.__component === collectionType + ".becomeparent" &&
                                                            <BecomeParent content={section} />
                                                        }
                                                        {
                                                            section.__component === collectionType + ".metoo" &&
                                                            <MeToo content={section} />
                                                        }
                                                        {
                                                            section.__component === collectionType + ".gotoworkshop" &&
                                                            <div style={{ position: 'relative', zIndex: 3 }}>
                                                                <GoToWorkshop content={section} />
                                                            </div>
                                                        }
                                                        {
                                                            section.__component === collectionType + ".coloredlist" &&
                                                            <ColoredList content={section} />
                                                        }
                                                        {
                                                            section.__component === collectionType + ".withworkshop" &&
                                                            <WithWorkshop content={section} />
                                                        }
                                                        {
                                                            section.__component === collectionType + ".imagine" &&
                                                            <Imagine content={section} />
                                                        }
                                                        {
                                                            section.__component === collectionType + ".steps" &&
                                                            <div style={{ position: 'relative', zIndex: 3 }}>
                                                                <Steps content={section} />
                                                            </div>
                                                        }
                                                        {
                                                            section.__component === collectionType + ".howithappen" &&
                                                            <div style={{ position: 'relative', zIndex: 3 }}>
                                                                <HowHappen content={section} />
                                                            </div>
                                                        }
                                                        {
                                                            section.__component === collectionType + ".bonusintro" &&
                                                            <BonusAnnounce content={section} />
                                                        }
                                                        {
                                                            section.__component === collectionType + ".modulessection" &&
                                                            <Bonus content={section} slug={slug} />
                                                        }
                                                        {
                                                            section.__component === collectionType + ".offer" &&
                                                            <div style={{ position: 'relative', zIndex: 3 }}>
                                                                <>
                                                                    <AccessOfferTitle content={section.Titre} />
                                                                    <AccessOfferFare content={section} />
                                                                </>
                                                            </div>
                                                        }
                                                        {
                                                            section.__component === collectionType + ".plans" &&
                                                            <Plans content={section} workshopTitle={displayData.TitrePage_section.TitrePage.Titre2} />
                                                        }
                                                        {
                                                            section.__component === collectionType + ".textwithpictures" &&
                                                            <TextWith2Pictures content={section} />
                                                        }
                                                        {
                                                            section.__component === collectionType + ".freetexte" &&
                                                            <FreeText content={section} />
                                                        }
                                                        {
                                                            section.__component === "shared.marge" &&
                                                            <Space content={section} />
                                                        }
                                                        {
                                                            section.__component === "shared.button" &&
                                                            <CustomBtn
                                                                type={isExternalLink(section.LienBouton) ? 'external' : 'internal'}
                                                                title={section.TexteBouton}
                                                                link={
                                                                    section.LienBouton === null ?
                                                                        ''
                                                                        :
                                                                        (isExternalLink(section.LienBouton) ?
                                                                            section.LienBouton
                                                                            :
                                                                            '/' + section.LienBouton)
                                                                }
                                                                bkg_color={'transparent'}
                                                                bkg_color_hover={'#EEE6DB'}
                                                                text_color={'#361215'}
                                                                text_color_hover={'#361215'}
                                                                border_color={'#361215'}
                                                                border_color_hover={'#361215'}
                                                                font_family={"Great Vibes"}
                                                                font_size={'30px'}
                                                                font_weight={'normal'}
                                                                border_radius={'3px'}
                                                                width={'360px'}
                                                                height={'55px'}
                                                                margin={'10px 0'}
                                                                letter_spacing={'3px'}
                                                            />
                                                        }
                                                    </React.Fragment>
                                                ))
                                            }
                                        </React.Fragment>
                                    ))
                                }
                            </div>
                    }
                </>
            }
        </div>
    );
}